import { Controller } from "@hotwired/stimulus";

// Owns the appointment-details drawer end to end: points the iframe at the
// clicked row's href and slides the panel in/out with a plain CSS transition.
//
// Closing re-adds `pointer-events-none` to the overlay synchronously, so the
// row beneath is clickable again the instant you close — the panel finishes
// sliding out on its own via the CSS transition. No timers, no second
// controller, so repeat open/close clicks can't race a half-finished animation.
//
// Also owns focus: `aria-hidden`/`inert` keep the closed panel out of the tab
// order and accessibility tree (see _drawer.html.erb), opening moves focus to
// the panel's close button, and closing restores it to whichever link
// triggered the open — including on Escape, so keyboard users don't lose
// their place or keep tabbing through the hidden panel.
export default class extends Controller {
  static targets = ["panel", "overlay", "frame", "close"];

  connect() {
    this.handleKeydown = (event) => {
      if (
        event.key === "Escape" &&
        !this.panelTarget.hasAttribute("aria-hidden")
      )
        this.close();
    };
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  open(event) {
    event.preventDefault();

    this.trigger = event.currentTarget;
    this.frameTarget.src = event.currentTarget.href;
    this.panelTarget.classList.remove("translate-x-full");
    this.overlayTarget.classList.remove("pointer-events-none");
    this.panelTarget.removeAttribute("aria-hidden");
    this.panelTarget.inert = false;
    this.closeTarget.focus();
  }

  close() {
    this.panelTarget.classList.add("translate-x-full");
    this.overlayTarget.classList.add("pointer-events-none");
    this.panelTarget.setAttribute("aria-hidden", "true");
    this.panelTarget.inert = true;
    this.trigger?.focus();
  }
}
